"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextSchema = exports.RichTextParagraphSchema = exports.RichTextRunSchema = void 0;
const zod_1 = require("zod");
const ColorOverride_1 = require("./ColorOverride");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.RichTextRunSchema = zod_1.z.object({
    value: zod_1.z.string(),
    bold: zod_1.z.boolean().optional(),
    italic: zod_1.z.boolean().optional(),
    sizePt: zod_1.z.number().optional(),
    color: ColorOverride_1.ColorOverrideSchema.optional(),
    font: zod_1.z.string().optional(),
});
exports.RichTextParagraphSchema = zod_1.z.object({
    runs: zod_1.z.array(exports.RichTextRunSchema),
});
exports.RichTextSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('rich-text'),
    pos: XYPosition_1.XYPositionSchema,
    width: zod_1.z.number(),
    height: zod_1.z.number(),
    paragraphs: zod_1.z.array(exports.RichTextParagraphSchema),
    defaultSizePt: zod_1.z.number().optional(),
    defaultBold: zod_1.z.boolean().optional(),
    defaultItalic: zod_1.z.boolean().optional(),
    defaultFont: zod_1.z.string().optional(),
    defaultColor: ColorOverride_1.ColorOverrideSchema.optional(),
});
//# sourceMappingURL=RichText.js.map